import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TouchEventService } from '../services/touch-event.service';
import { timer } from 'rxjs/observable/timer';
import { BaseComponent } from '../Models/BaseComponent';

import {DomSanitizer,SafeResourceUrl} from '@angular/platform-browser';
import { IntegrationService } from '../services/integration.service';


@Component({
  selector: 'app-integration-complete',
  templateUrl: './integration-complete.component.html',
  styleUrls: ['./integration-complete.component.css']
})
export class IntegrationCompleteComponent extends BaseComponent implements OnInit {

  profileId: string;
  returnUrl: string;
  detailUrl: SafeResourceUrl;

  constructor(public location : Router, 
                public swiper : TouchEventService, 
                public route : ActivatedRoute,
                public sanitizer:DomSanitizer,
                public integration: IntegrationService) {
    super(swiper,location);

    this.profileId=this.route.snapshot.paramMap.get('profileId');
    
    this.integration.fetchintegrationProfile(this.profileId).subscribe((data) => {
      this.integration.integrationProfile = data;
      this.returnUrl=this.integration.integrationProfile.returnUrl;
      this.detailUrl=this.sanitizer.bypassSecurityTrustResourceUrl('https://icims.synergipartners.com/detail/'+this.profileId);
    })
  }

  ngOnInit() {
    window.history.pushState(window.location.href, '', window.location.origin);
    document.getElementsByClassName('container')[0].classList.remove('slide-backward');
    document.getElementsByClassName('container')[0].classList.add('slide-forward');
    var tim = timer(0);
    tim.subscribe(t => {
      document.getElementsByClassName('container')[0].classList.remove('slide-forward');
    });
  }

  return() : void {
    window.location.href=this.returnUrl;
  }
  
}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/integration-complete/integration-complete.component.ts